import SiteMission from "./SiteMission/SiteMission";
import SitePossibilities from "./SitePossibilities/SitePossibilities";
import HomeStoriesSlider from "./HomeStoriesSlider/HomeStoriesSlider";
import Pets from "./Pets/Pets";

const Home = () => {
  return (
    <>
      <SiteMission />
      <SitePossibilities />
      <HomeStoriesSlider />
      <Pets />
    </>
  );
};

export default Home;
